import type { AdminLoginResponse } from '@/types/auth'

const AUTH_SESSION_KEY = 'ask-spinner-admin:auth-session'

export const AUTH_SESSION_EXPIRED_EVENT = 'ask-spinner-admin:session-expired'

export interface AuthSession {
  tokenName: string
  tokenValue: string
  timeout: number
}

export function readAuthSession(): AuthSession | null {
  try {
    const value = window.localStorage.getItem(AUTH_SESSION_KEY)
    if (!value) return null

    const session = JSON.parse(value) as Partial<AuthSession>
    if (!session.tokenName || !session.tokenValue) return null

    return {
      tokenName: session.tokenName,
      tokenValue: session.tokenValue,
      timeout: Number(session.timeout || 0)
    }
  } catch {
    window.localStorage.removeItem(AUTH_SESSION_KEY)
    return null
  }
}

export function saveAuthSession(response: AdminLoginResponse) {
  const session: AuthSession = {
    tokenName: response.tokenName,
    tokenValue: response.tokenValue,
    timeout: response.timeout
  }
  window.localStorage.setItem(AUTH_SESSION_KEY, JSON.stringify(session))
}

export function clearAuthSession() {
  window.localStorage.removeItem(AUTH_SESSION_KEY)
}
